import $ from 'jquery';
import debounce from '../helpers/debounce';

class NotificationsCenter {
  constructor() {
    this._init();
  }

  _init() {
    this.debounced = debounce(this.showNotifications, 250);
    this.hourglass = `<span class="loader circle-spin"></span>`;
    this.isMobile = false;

    const notifications = $('*[data-notifications-center]');
    notifications.each((index, el) => {

      this.elm = $(el);
      this.targetId = $(this.elm).data('toggle');
      console.log("A", this.targetId)
      this.target = $(`#${this.targetId}`);

      if (this.target.length) {
        $(this.elm).on('click', '', (event) => {
          this.isMobile = false;
          console.log($(this.elm).parent().toggleClass("l-navbar__user__item--active"));
          event.preventDefault();
          $("#notifications-notify-container").hide()
          $(this.target).html(this.hourglass);
          this.debounced();
        });
      } else {
        throw new Error('NotificationsCenter target not found.');
      }
    });

    const notificationsMobile = $('*[data-notifications-center_mobile]');
    notificationsMobile.each((index, el) => {

      this.elm = $(el);
      this.targetIdMobile = $(this.elm).data('toggle');
      this.targetMobile = $(`#${this.targetIdMobile}`);

      if (this.targetMobile.length) {
        $(this.elm).on('click', '', (event) => {
          this.isMobile = true;
          console.log($(this.elm).parent().toggleClass("l-navbar__user__item--active"));
          event.preventDefault();
          $("#notifications-notify-container_mobile").hide()
          $(this.targetMobile).html(this.hourglass);
          this.debounced();
        });
      } else {
        throw new Error('NotificationsCenter target not found.');
      }
    });

  }



  fecthNotifications() {
    return $.ajax({
      url: '/'+$("html").attr("lang")+'/users/me/notifications',
      type: 'GET',
      dataType: 'HTML',
    });
  }

  showNotifications() {
    const notificationsHtml = this.fecthNotifications();
    notificationsHtml.then(html => {
      let content = $(html).fadeOut(0);

      if (!this.isMobile) {
        $(this.target).append(content);
        console.log(this.isMobile, $(this.target), $(this.target).html())
          $(this.target).find('.loader').fadeOut(600, cb => {
            $(content).fadeIn(600);
          });
      } else {
          $(this.targetMobile).append(content);
          console.log(this.isMobile, $(this.targetMobile), $(this.targetMobile).html())
          $(this.targetMobile).find('.loader').fadeOut(600, cb => {
            $(content).fadeIn(600);
          });

      }

    })


  }
}

export default new NotificationsCenter;
